enum FormInputType {
  Text,
  Dropdown,
  KargoDropdown,
  Checkbox,
}

export { FormInputType };
